module.exports = __webpack_public_path__ + "img/colaboration-of-film-school.99ed5fbb.png";